module.exports = __webpack_public_path__ + "static/media/icon-fr.6ffdf42a.png";